module.exports = __webpack_public_path__ + "static/media/exclamation.72b2c528.svg";